





































import { ref, defineComponent, toRefs, reactive } from '@vue/composition-api'

import { addCategory } from '@/shared/api'
import { Textbook } from '@/shared/types'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'CreateCategory',
  components: {
    CloseButton,
  },
  props: {
    textbook: Object,
  },
  setup(props, context) {
    const createCategoryForm = ref(null)

    const data = reactive({
      valid: true,
      name: '',
      nameRules: [
        (v: string) =>
          !!v || context.root.$t('createCategoryForm.name.required'),
      ],
    })

    const loading = ref(false)

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = createCategoryForm.value
      if (!form.validate()) {
        return
      }

      loading.value = true
      try {
        const createdCategory = await addCategory(
          (props.textbook as Textbook).id,
          data.name
        )
        context.emit('category-created', createdCategory)
        form.reset()
        loading.value = false
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      loading,
      createCategoryForm,
      submit,
    }
  },
})
